/**
 * Evaluates a string preference as a boolean.
 * Prefs come from CMS as strings. This normalizes the check.
 *
 * @param {string} value - The pref value
 * @param {boolean} [defaultValue=false] - What to return if value is undefined/null
 * @returns {boolean}
 */
export const isPrefEnabled = (value, defaultValue = false) => {
	if (value === undefined || value === null) return defaultValue;
	return value !== 'false';
};

/**
 * Evaluates an 'enabled'/'disabled' schema preference.
 * Returns true only when the value is explicitly 'enabled'.
 *
 * Use this for prefs that use 'enabled'/'disabled' values.
 * Do NOT use isPrefEnabled for these — isPrefEnabled('disabled') returns true
 * because it checks value !== 'false', not value === 'enabled'.
 *
 * @param {string} value - The pref value
 * @returns {boolean}
 */
export const isPrefValueEnabled = (value) => value === 'enabled';
